import { Column, div, Flex, Loading } from "lqx-react";
import React from "react";
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';
import { AssetEventLatest, AssetEventProcessStatus } from "../api/assetEvent";
import { DigiTooltip } from "../shared";
import { ExternalSystem } from "../api/externalSystemRequest";
import { styled } from "@material-ui/core";

export const InblockedAssetEventStatusItemList = ({ assetEvent, externalSystem }: {
    assetEvent: AssetEventLatest,
    externalSystem: ExternalSystem
}) => {

    return <ExternalSystemColumn key={externalSystem.assetEventType}>
        {
            assetEvent &&
            <>
                {(assetEvent.assetEventStatus == AssetEventProcessStatus.processing) &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <>
                            {<Flex row key={assetEvent.id}>{externalSystem.waitingMessage}.</Flex>}
                        </>
                    }>
                        <LoadingContainer key={assetEvent.eventTypeId}>
                            <Loading />
                        </LoadingContainer>
                    </DigiTooltip>
                }
                {assetEvent.assetEventStatus == AssetEventProcessStatus.finished && assetEvent.success &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <span>{externalSystem.successMessage}. {assetEvent.message}</span>
                    }>
                        <Success><CheckIcon /></Success>
                    </DigiTooltip>
                }
                {assetEvent.assetEventStatus == AssetEventProcessStatus.finished && !assetEvent.success &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <span>{externalSystem.failMessage}. {assetEvent.message}</span>
                    }>
                        <Warning><WarningIcon /></Warning>
                    </DigiTooltip>
                }
            </>
        }
    </ExternalSystemColumn>
}

const LoadingContainer = div({
    marginTop: '3px',
    marginLeft: '5px',
    maxWidth: '20px',
    maxHeight: '20px',
    '& .MuiCircularProgress-root': {
        maxWidth: '20px',
        maxHeight: '20px',
    }
});

const Warning = div({
    color: '#eabc5e'
});

const Success = div({
    color: '#4197d6'
});

const ExternalSystemColumn = styled(Column)({
    maxWidth: '25px',
    margin: 0,
    padding: '2px'
});
